module.exports = __webpack_public_path__ + "img/7181747.png";